import _get from 'lodash/get';

export const parseErrorResponse = error => {
    let errorMessage = _get(error, 'response.data.message', '');
    errorMessage = errorMessage ? errorMessage : _get(error, 'message', '');
    errorMessage = errorMessage ? errorMessage : _get(error, 'response.status', 'Unknown error.');
    return errorMessage;
};
